import { Outlet, Link, useLocation } from 'react-router-dom';
import { MessageSquare, FolderOpen, BookOpen, Settings, Scissors } from 'lucide-react';
import clsx from 'clsx';

const navItems = [
  { path: '/', icon: MessageSquare, label: 'Chat' },
  { path: '/projects', icon: FolderOpen, label: 'Projects' },
  { path: '/knowledge', icon: BookOpen, label: 'Knowledge' },
];

export function Layout() {
  const location = useLocation();

  return (
    <div className="flex h-screen bg-[#0a0a0b]">
      {/* Sidebar */}
      <aside className="w-64 bg-[#111113] border-r border-zinc-800 flex flex-col">
        {/* Logo */}
        <div className="p-4 border-b border-zinc-800">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-progeny-600 rounded-lg flex items-center justify-center">
              <Scissors className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="font-semibold text-white">Progeny AI</h1>
              <p className="text-xs text-zinc-500">Pattern Intelligence</p>
            </div>
          </Link>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-3">
          <ul className="space-y-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={clsx(
                      'flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors',
                      isActive
                        ? 'bg-progeny-600/20 text-progeny-400'
                        : 'text-zinc-400 hover:bg-zinc-800 hover:text-white'
                    )}
                  >
                    <item.icon className="w-5 h-5" />
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Settings */}
        <div className="p-3 border-t border-zinc-800">
          <button className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-zinc-400 hover:bg-zinc-800 hover:text-white w-full transition-colors">
            <Settings className="w-5 h-5" />
            Settings
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 flex flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}

